import { PERMISSIONS } from '@/libs/acl/permissions'

export default [
  {
    path: '/apps/settings/general',
    name: 'general-settings',
    component: () => import('@/views/apps/settings/GeneralSettings.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_GENERAL_SETTINGS,
      action: 'read',
      pageTitle: 'General Settings',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Settings',
        },
        {
          text: 'General Settings',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/settings/fee',
    name: 'fee-settings',
    component: () => import('@/views/apps/settings/FeeSettings.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_FEE_SETTINGS,
      action: 'read',
      pageTitle: 'Fee Settings',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Settings',
        },
        {
          text: 'Fee Settings',
          active: true,
        },
      ],
    },
  },
]
